import React from 'react';
import { Label } from 'react-bootstrap';

export const getPriceNegotiationLabels = (priceNegotiation, messages) => {
  const labels = [];
  switch (priceNegotiation.current_offer_for) {
    case 'owner':
      labels.push(
        <Label key="for-owner" className="m-r-20">
          {messages.no_reply_yet}
        </Label>
      );
      break;

    case 'target':
      if (!priceNegotiation.has_order) {
        labels.push(
          <Label bsStyle="success" key="for-target" className="m-r-20">
            {messages.employee_replied}
          </Label>
        );
      }
      break;
  }

  return labels;
};
